






import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      windowHeight: 0,
      positionTop: 0
    };
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },

    emitChange() {
      this.$emit('height-change', {
        windowHeight: this.windowHeight,
        positionTop: this.positionTop
      });
    }
  },

  watch: {
    windowHeight() {
      this.emitChange();
    }
  },

  mounted() {
    const box = (this.$refs['boundingBox'] as Element).getBoundingClientRect();

    this.positionTop = box.top;
    this.windowHeight = window.innerHeight;

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
});
